// Import model
import { DataviewPickListItemResponse } from '../models/DataviewPickListItemResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterPickListItemRequest } from '../models/FilterPickListItemRequest';
import { PickListItem } from '../models/PickListItem';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterPickListItemRequestSerializer } from './FilterPickListItemRequestSerializer';
import { PickListItemSerializer } from './PickListItemSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewPickListItemResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewPickListItemResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewPickListItemResponse instance
   */
  static deserialize(json: string): DataviewPickListItemResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewPickListItemResponse instance
   */
  static fromObject(obj: any): DataviewPickListItemResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewPickListItemResponse');
    }


    const instance: DataviewPickListItemResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        PickListItemSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterPickListItemRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewPickListItemResponse instances
   */
  static deserializeArray(json: string): DataviewPickListItemResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewPickListItemResponse instance to a JSON string
   */
  static serialize(instance: DataviewPickListItemResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewPickListItemResponse instance to a plain object
   */
  static toObject(instance: DataviewPickListItemResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        PickListItemSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterPickListItemRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewPickListItemResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewPickListItemResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
